var map = {
	"./aavegotchi/index.ts": "8e86",
	"./balance-of-with-min/index.ts": "6cb4",
	"./balancer-delegation/index.ts": "4a6a",
	"./balancer-unipool/index.ts": "e3fe",
	"./balancer/index.ts": "09e9",
	"./contract-call/index.ts": "070e",
	"./cream/index.ts": "4249",
	"./ctoken/index.ts": "687b",
	"./defidollar/index.ts": "6727",
	"./delegation/index.ts": "da7c",
	"./dittomoney/index.ts": "2128",
	"./ens-domains-owned/index.ts": "3753",
	"./ens-reverse-record/index.ts": "ac4e",
	"./erc1155-balance-of-cv/index.ts": "84e9",
	"./erc1155-balance-of/index.ts": "4b83",
	"./erc20-balance-of-coeff/index.ts": "c308",
	"./erc20-balance-of-cv/index.ts": "f3ec",
	"./erc20-balance-of-delegation/index.ts": "0614",
	"./erc20-balance-of-fixed-total/index.ts": "d71a",
	"./erc20-balance-of/index.ts": "9d58",
	"./erc20-received/index.ts": "b354",
	"./erc20-with-balance/index.ts": "bc48",
	"./esd-delegation/index.ts": "9287",
	"./esd/index.ts": "7802",
	"./eth-balance/index.ts": "ecf8",
	"./eth-philanthropy/index.ts": "0ac6",
	"./eth-received/index.ts": "05bf",
	"./eth-wallet-age/index.ts": "8b83",
	"./frax-finance/index.ts": "3cf3",
	"./ilv/index.ts": "0be0",
	"./index.ts": "f5d2",
	"./maker-ds-chief/index.ts": "ca26",
	"./masterchef/index.ts": "bafc",
	"./mithcash/index.ts": "2ff9",
	"./moloch/index.ts": "88bd",
	"./ocean-marketplace/index.ts": "60c5",
	"./opium/index.ts": "790f",
	"./pancake/index.ts": "90eb",
	"./piedao/index.ts": "44cc",
	"./rebased/index.ts": "6368",
	"./stablexswap/index.ts": "30b7",
	"./staked-keep/index.ts": "9b9b",
	"./staked-uniswap/index.ts": "060f",
	"./sushiswap/index.ts": "e21d",
	"./synthetix/index.ts": "84ae",
	"./the-graph-balance/index.ts": "7456",
	"./the-graph-delegation/index.ts": "29a8",
	"./the-graph-indexing/index.ts": "1e29",
	"./ticket-validity/index.ts": "990c",
	"./ticket/index.ts": "64e0",
	"./tokenlon/index.ts": "3921",
	"./typhoon/index.ts": "8164",
	"./uni/index.ts": "9d75",
	"./uniswap/index.ts": "17a0",
	"./whitelist/index.ts": "3d05",
	"./work/index.ts": "9975",
	"./xdai-stake-delegation/index.ts": "4b0b",
	"./xdai-stake/index.ts": "a5cb",
	"./yearn-vault/index.ts": "a790"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6407";